import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IGroupFormDialogData {
    financialLineItemsOptions: INameId[];
    existingGroupsNames: string[];
}
